export const LINE_RENDERING = {
  COLOR: '238, 244, 244',
  MIN_ALPHA: 0.2,  // Increased minimum opacity
  MAX_ALPHA: 0.5,  // Increased maximum opacity
  MIN_WIDTH: 0.8,  // Increased minimum width
  MAX_WIDTH: 2.5,  // Increased maximum width
  CONNECTION_DISTANCE: 180,  // Slightly reduced to make connections more deliberate
  MOBILE_CONNECTION_DISTANCE: 120, // Reduced connection distance for mobile
};

export const PARTICLE_CONFIG = {
  BASE_COUNT: 65,
  MOBILE_COUNT: 30,  // Reduced count for mobile
  TABLET_COUNT: 45,  // Medium count for tablets
  PER_CLICK: 8,
  MOBILE_PER_CLICK: 4, // Reduced particles per click for mobile
  MAX_COUNT: 300,
  MOBILE_MAX_COUNT: 150, // Reduced max count for mobile
  SIZE: 3.3,
  BASE_SPEED: 2,  // Reduced speed for more stable connections
  ORBITAL_SPEED: 0.02,  // Reduced orbital speed
};

export const PERFORMANCE = {
  CHECK_INTERVAL: 1000,
  MIN_FPS: 60,
  CLICK_COOLDOWN: 200,
  CLICK_BATCH_LIMIT: 3
};

export const GRADIENTS = {
  START: '#7767eb',
  END: '#011f2fde'
};

export const PHYSICS = {
  THICKNESS: Math.pow(11, 3.5),
  DRAG: 0.995,  // Increased drag for smoother movement
  MOUSE_FORCE: 800,
  MOUSE_RADIUS: 80,  // Increased influence radius
  REPULSION_SPEED: 0.3,  // Reduced repulsion speed for smoother movement
  MIN_DIST: 5,
  CLICK_FORCE: 250,
  CLICK_RADIUS: 150,
  CLICK_COOLDOWN: 200,
  CLICK_BATCH_LIMIT: 3,
  REDISTRIBUTION_COUNT: 4,
  REDISTRIBUTION_RADIUS: 70,
  DISTRIBUTION_DECAY: 0.95,
};
